import { Color } from "utils/theme";
import { FuelCurveView } from "./views/fuel-curve-view";
import { isCanvasSupported } from "utils/canvas";

export const FuelCurveScreen = () => {
  if (!isCanvasSupported()) {
    return (
      <section className="h-full flex flex-col items-center justify-center">
        <p
          className="text-2xl font-semibold max-w-md text-center leading-9"
          style={{ color: Color.Primary[400] }}
        >
          Cannot display graph view. Canvas is not supported on your device.
        </p>
      </section>
    );
  }

  return (
    <section className="h-full flex flex-col overflow-auto p-2">
      <FuelCurveView />
    </section>
  );
};
